/**
 * HELM's view bar (A7Y-5210): Today, This week, Board and Accounts are one
 * system, so every one of their pages — and the account page, which belongs to
 * Accounts — opens with the same bar. The routes keep their paths (the last
 * three live under `/admin/cmo/crm`); only what the reader sees is one surface.
 */
import { Link, useLocation } from 'react-router-dom';
import { HELM_VIEWS, helmViewOf } from './helmViewModel';

export function HelmViewNav() {
  const { pathname } = useLocation();
  const current = helmViewOf(pathname);
  return (
    <nav aria-label="HELM views" data-testid="helm-view-nav" className="px-2 pb-4">
      <ul className="flex flex-wrap gap-1 border-b border-zinc-200 dark:border-zinc-700">
        {HELM_VIEWS.map((view) => {
          const active = view.id === current;
          return (
            <li key={view.id}>
              <Link
                to={view.to}
                data-testid={`helm-view-${view.id}`}
                aria-current={active ? 'page' : undefined}
                className={`-mb-px inline-flex min-h-11 items-center border-b-2 px-3 text-sm font-medium sm:min-h-9 ${
                  active
                    ? 'border-zinc-900 text-zinc-900 dark:border-white dark:text-white'
                    : 'border-transparent text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white'
                }`}
              >
                {view.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
